module.exports = __webpack_public_path__ + "img/barrage_prize_03.2526fa2d.png";